<template>
  <div class="mobile_wrap_businessIntroduction wow fadeInUp">
    <el-row v-for="(itm,inx) in serviceArray" :key="inx">
      <el-col :span="1" class="header_block"></el-col>
      <el-col :span="22" class="header_block">
      <div
        class=" server_box"
        v-for="(item,index) in itm"
        :key="index"
      >
        <img :src="item.url" class="server_img" />
        <p class="server_title">{{item.title}}</p>
        <p class="server_titleEng">{{item.titleEng}}</p>
      </div>
      </el-col>
      <el-col :span="1" class="header_block"></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "businessIntroduction",
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },
  data() {
    return {
      serviceArray: [
        [{
          url: require("@/assets/imgs/a1.png"),
          title: "对标分析",
          titleEng: "对标账号内容分析、数据分析、运营分析。"
        },
        {
          url: require("@/assets/imgs/a2.png"),
          title: "账号定位",
          titleEng: "账号定位、内容设动，IP设置、垂直深耕。"
        },
        {
          url: require("@/assets/imgs/a3.png"),
          title: "脚本生产",
          titleEng: "设置情境-打造人设-树立账号风格-脚本创意。"
        },
        {
          url: require("@/assets/imgs/a4.png"),
          title: "视频制作",
          titleEng: "演员选定-拍摄-剪辑-包装-封面设计-成片出品。"
        },
        {
          url: require("@/assets/imgs/a5.png"),
          title: "话题生产、蹭热点",
          titleEng: "适当借势，当下话题，内容多样化。"
        }],
        [{
          url: require("@/assets/imgs/a6.png"),
          title: "粉丝增长",
          titleEng: "运营、互动、采购，组合拳助力粉丝增长。"
        },
        {
          url: require("@/assets/imgs/a7.png"),
          title: "其他方式",
          titleEng: "直播造势，引爆舆论热点。 "
        },
        {
          url: require("@/assets/imgs/a8.png"),
          title: "评论互动",
          titleEng: "评论收集、评论回复、互动"
        },
        {
          url: require("@/assets/imgs/a9.png"),
          title: "用户维护 ",
          titleEng: "维护用户，帮助涨粉"
        },
        {
          url: require("@/assets/imgs/a10.png"),
          title: "运营分析 ",
          titleEng: "每月提供专业运营报告，及时提供数据反馈，做出运营调整。"
        }]
      ]
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.mobile_wrap_businessIntroduction {
  .header_block {
    min-height: 10px;
  }
  .server_box {
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    float: left;
    .server_img {
      // width: 45%;
      width: 32px;
      height: 32px;
    }
    .server_title {
      font-size: 14px;
    color: #676767;
    line-height: 50px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    text-align: left;
    }
    .server_titleEng {
      font-size: 12px;
    color: #676767;
    line-height: 24px;
    // padding: 10px 20px;
      margin-bottom: 20px;
      text-align: left;
      width: 100%;
      // box-shadow: 0 28px 46px 0 rgba(0, 0, 0, 0.12);
    }
  }
}
</style>



